import { Hero } from '../components/common/hero';
import { Main } from '../components/layout/main';

export const PageNotFound = () => {
	return (
		<Main>
			<Hero title='Page Not Found :(' />
		</Main>
	);
};
